export const eventTypes = {
    'flow.activated': {
        name: 'Flow activated',
        description: 'A flow version was set as the active one',
    },
    'flow.deactivated': {
        name: 'Flow deactivated',
        description: 'A flow version was deactivated',
    },
    'flow.initialized': {
        name: 'Flow initialized',
        description: 'A flow was initialized, probably also creating a new state unless an initialization error occurred',
    },
    'flow.loaded': {
        name: 'Flow loaded',
        description: 'A flow was loaded',
    },
    'flow.package.exported': {
        name: 'Flow package exported',
        description: 'A flow package was exported',
    },
    'flow.package.imported': {
        name: 'Flow package imported',
        description: 'A flow package was imported',
    },
    'flow.package.shared': {
        name: 'Flow package shared',
        description: 'A flow package was shared using a sharing token',
    },
    'flow.restriction.denied': {
        name: 'Flow restriction denied',
        description: 'Access or execution of a flow was denied',
    },
    'flow.saved': {
        name: 'Flow saved',
        description: 'A flow was saved',
    },
    'tenant.clearing.applied': {
        name: 'Tenant clearing applied',
        description: 'Deletion of all data in a tenant was performed',
    },
    'tenant.clearing.requested': {
        name: 'Tenant clearing requested',
        description: 'Deletion of all data in a tenant was requested',
    },
    'tenant.created': {
        name: 'Tenant created',
        description: 'A new tenant was created',
    },
    'tenant.deletion.applied': {
        name: 'Tenant deletion applied',
        description: 'A tenant was deleted',
    },
    'tenant.deletion.requested': {
        name: 'Tenant deletion requested',
        description: 'A request was made to delete a tenant',
    },
    'tenant.loaded': {
        name: 'Tenant loaded',
        description: 'A tenant was loaded',
    },
    'tenant.saved': {
        name: 'Tenant saved',
        description: 'A tenant was saved',
    },
    'tenant.store.deleted': {
        name: 'Tenant store deleted',
        description: 'A tenant store was deleted',
    },
    'tenant.store.migration.requested': {
        name: 'Tenant store migration requested',
        description: 'A tenant store migration was requested',
    },
    'tenant.store.saved': {
        name: 'Tenant store saved',
        description: 'A tenant store was saved',
    },
    'tenant.user.added': {
        name: 'Tenant user added',
        description: 'A user was added to a tenant',
    },
    'tenant.user.denied': {
        name: 'Tenant user denied',
        description: 'A user was denied access to a tenant',
    },
    'tenant.user.loaded': {
        name: 'Tenant user loaded',
        description: 'A user profile was loaded',
    },
    'tenant.user.role.updated': {
        name: 'Tenant user role updated',
        description: 'User role was updated and saved',
    },
    'tenant.user.removed': {
        name: 'Tenant user removed',
        description: 'A user was removed from a tenant',
    },
    'user.password.reset': {
        name: 'User password reset',
        description: 'User password reset process was initiated',
    },
    'user.password.reset.applied': {
        name: 'User password reset applied',
        description: 'User password reset process was performed',
    },
    'user.login.draw': {
        name: 'User login draw',
        description: 'User logged in into a tenant',
    },
    'user.login.draw.denied': {
        name: 'User login draw denied',
        description: 'User was denied login in into tenant',
    },
    'user.login.run': {
        name: 'User login run',
        description: 'User logged in into a running flow',
    },
    // there is code in Engine, but no one calls this event
    // 'user.login.run.denied': {
    //   name: '',
    //   description: '',
    // }
};

export function getEventType(type) {
    if (type in eventTypes) {
        return eventTypes[type];
    }

    return {
        name: type,
        description: '',
    };
}
